import * as Yup from 'yup';
import * as moment from 'moment';
import { BIDFORMAT } from '../utils/dateOfBirthValidation';
import { prohibitedBusinessURLs } from 'web/pages/account/registration/Constants';
export function getRegisterInitialValues(email, referralDefault) {
  let date = new Date();
  let plusTwo = date.setFullYear(date.getFullYear() - 18)
  let dateSet = new Date(plusTwo)

  let bidDate = moment(dateSet).format(BIDFORMAT)

  return {
    companyName: '',
    DBAName: '',
    name: '',
    password: '',
    confirmPassword: '',
    email: email ? email : '',
    line1: '',
    line2: '',
    smsPhNumber: '',
    locationST: '',
    locationCity: '',
    locationZip: '',   
    referralCode: '',
    promoCodeInput: referralDefault ? referralDefault : '',
    promoOrReferralValidated: false,
    diverseSpendSelectedList: [],
    role: '',
    reseller: '',
    buyerSellerOption: '',

    taxId: '',
    dnbNum: '',
    creditRef: '',
    paymentTerm: '30',
    businessUrl: '',
    businessDesc: '',
    taxidLicense: '0',

    drivingLicense: '',
    dob: bidDate,
    drivingLicenseDoc: '',
    ssn: '',
    firstName: '',
    lastName: '',
    accountToken: '',

    // Step4
    accountType: '',
    cardHolderName: '',
    accountHolderName: '',
    bankAccount: '',
    cardNumber: '',
    exp: '',
    cvc: '',
    bankRouting: '',
    otp:'',

    // Step5
    buyerRadioType: '',
    acceptPromo: false,

    //validations
    buyerPaymentValidated: false,
    sellerPaymentValidated: false,
    membershipPaymentValidated: false,
  };
}

const step1Schema = (propState, taxidState, pageLanguageContents) => {
  let schemaAttributes;

  schemaAttributes = {
    companyName: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[0]?.CompanyNameReq).min(3, 'Company name must have at least 3 characters'),
    DBAName: Yup.string().trim().min(3, 'DBA must have at least 3 characters'),
    name: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[1]?.FullNameReq).min(3, 'Name must have at least 3 characters'),
    password: Yup.string().trim()
      .label('Password')
      .required("Please enter a valid password")
      .matches(/[a-z]+/, "Password isn't secure.")
      .matches(/[A-Z]+/, "Password isn't secure.")
      .matches(/[@$!%*#?&]+/, "Password isn't secure.")
      .matches(/\d+/, "Password isn't secure.")
      .min(8, "Password should be more than 8 characters.")
      .max(20, "Please enter a valid password"),
    confirmPassword: Yup.string().trim()
      .required(pageLanguageContents?.ErrorValidations[5]?.PasswordMatch)
      .oneOf(
        [Yup.ref('password'), null],
        'Passwords must match'
      ),
    email: Yup.string().trim()
      .email(pageLanguageContents?.ErrorValidations[6]?.ValidEmail)
      .required(pageLanguageContents?.ErrorValidations[7]?.EmailReq)
    // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,pageLanguageContents?.ErrorValidations[6]?.ValidEmail)
    ,
    smsPhNumber: Yup.string().trim().required('Phone Number is required.').matches(/^\D*(\d\D*){10}\D*$/, 'Phone Number is invalid.')
      .test('hasNonZero', 'Phone Number is invalid.', function (value) {
        if (value) {
          const regex = /[1-9]/;
          return regex.test(value);
        }
        return true;
      }),
    line1: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[8]?.AddressReq).min(3, 'Address line 1 must have at least 3 characters'),
    line2: Yup.string().trim().min(3, 'Address line 2 must have at least 3 characters'),
    locationCity: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[9]?.CityReq).min(3, 'City must have at least 3 characters'),
    locationST: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[10]?.StateReq),
    locationZip: Yup.string().trim().min(5, pageLanguageContents?.ErrorValidations[11]?.TooShort).required(pageLanguageContents?.ErrorValidations[12]?.ZipFiveReq),
    businessUrl: Yup.string().trim()
        .matches(
          /^(https?):\/\/[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,}){1,3}([/?#].*)?$/,
        pageLanguageContents?.ErrorValidations[15]?.UrlError)
        .test('prohibited-urls', 'This URL is prohibited. Please enter another URL.', value => {
          if (!value) return true; // Skip the check if value is empty
          const d = value.replace(/^(?:https?:\/\/)?(?:www\.)?/, '');// Remove prefixes
          const domain = d.replace(/\/$/, ''); // Remove trailing slash
          return !prohibitedBusinessURLs.includes(domain);
        }),

    modeOfContact: Yup.string().trim().required('Choose one option'),
    modeOfContactOther: Yup.string().when('modeOfContact',
      (modeOfContact, schema) => {
        if (modeOfContact === "Other") {
          return schema.required('Please enter the details')
        } else {
          return schema
        }
      }),
    appliedPromoCodeDetails: '',
  };
  return Yup.object().shape(schemaAttributes);
}
const step2Schema = (propState, selectTaxId, pageLanguageContents) => {
  let schemaAttributes;

  if (selectTaxId === "0") {
    schemaAttributes = {
      taxId: Yup.string().trim().min(9, pageLanguageContents?.ErrorValidations[13]?.TaxMinNine).required(pageLanguageContents?.ErrorValidations[14]?.TaxReq),
    }
  } else if (selectTaxId === "1") {
    schemaAttributes = {
      drivingLicense: Yup.string().trim().min(7, "Driver's License Number should be minimum 7 digits.").required(pageLanguageContents?.ErrorValidations[17]?.LicenseReq),
      drivingLicenseState: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[10]?.StateReq),
      firstName: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[18]?.FirstNameReq),
      lastName: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[19]?.LastNameReq),
      drivingLicenseDoc: Yup.string().trim().required(''),
      dob: Yup.date()
        .required(pageLanguageContents?.ErrorValidations[20]?.AgeEighteen).nullable()
        .transform(v => (v instanceof Date && !isNaN(v) ? v : null))
        .test("dob", pageLanguageContents?.ErrorValidations[20]?.AgeEighteen, (value) => {
          return moment().diff(moment(value), 'years') >= 18;
        }),
    }
  }
  return Yup.object().shape(schemaAttributes);
}
const step3Schema = () => {
}
export function getRegisterSchema() {
  return [step1Schema, step2Schema, step3Schema];
}

